import { ViewFactory } from 'wdc-cube-react'

import { BillingHeaderScope, BillingScope } from '../bl_scopes'
import BillingHeaderView from './bl-header'
import BillingView from './bl_view'

export function registerViews(rv = ViewFactory.register) {
    rv(BillingScope, BillingView)
    rv(BillingHeaderScope, BillingHeaderView)
}
export { default as BillingInvoiceDialogView } from './bl_invoice_dialog'
